import { useEffect, useState } from 'react';
/**
 * Função para transformar media query em variável
 *
 * @example
 * ```typescript
 * export default function Example() {
 *   const isDesktop = useMediaQuery("(min-width: 768px)");
 *   const myVar = isDesktop ? "desktop" : "mobile";
 *   return <div>{myVar}</div>;
 * }
 * ```
 *
 * @export
 * @param {string} query
 * @return {*}  {boolean}
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);

    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}
